export default __webpack_public_path__ + "static/media/Navratri_yellow_gradient.052977b1.gif";